import { render } from "./Analyprofit2.vue?vue&type=template&id=6baf2c5a&scoped=true&ts=true"
import script from "./Analyprofit2.vue?vue&type=script&lang=ts"
export * from "./Analyprofit2.vue?vue&type=script&lang=ts"

import "./Analyprofit2.vue?vue&type=style&index=0&id=6baf2c5a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6baf2c5a"]])

export default __exports__